import styled from 'styled-components';

export const DeleteContainer = styled.div`
  display: flex;
  margin: 24px 0;

  .ant-form-item {
    width: 288px;
  }

  & > div:last-child {
    cursor: pointer;
    align-self: flex-start;
    margin-left: 18px;
    margin-top: 33px;
  }
`;
